import { render } from "./GoGrassImageMapScreen.vue?vue&type=template&id=42b15050&scoped=true&ts=true"
import script from "./GoGrassImageMapScreen.vue?vue&type=script&lang=ts"
export * from "./GoGrassImageMapScreen.vue?vue&type=script&lang=ts"

import "./GoGrassImageMapScreen.vue?vue&type=style&index=0&id=42b15050&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b15050"]])

export default __exports__